import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import AddCircleOutlineOutlined from "@mui/icons-material/AddCircleOutlineOutlined";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import ListAltIcon from "@mui/icons-material/ListAlt";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import OrderAppraisalIcon from "../../assets/icons/order-appraisal";
import ScheduleTrainingIcon from "../../assets/icons/schedule-training";
import PlayCircleOutlinedIcon from "@mui/icons-material/PlayCircleOutlined";
import { faDollarSign } from "@fortawesome/free-solid-svg-icons";

export const drawerTopData = [
	{
		title: "Home",
		url: "home",
		path: "/home",
		icon: <HomeOutlinedIcon sx={{ fontSize: "32px" }} />,
	},
	{
		title: "Add New Loan",
		url: "new-loan",
		path: "/new-loan",
		icon: <AddCircleOutlineOutlined sx={{ fontSize: "32px" }} />,
	},
	{
		title: "Loan Upload History",
		url: "upload-history",
		path: "/upload-history",
		icon: <ListAltIcon sx={{ fontSize: "32px" }} />,
	},
	{
		title: "Loan Pipeline",
		url: ["pipeline", "loan-summary"],
		path: "/pipeline",
		icon: <DashboardOutlinedIcon sx={{ fontSize: "32px" }} />,
	},
	{
		title: "Quick Pricer",
		url: ["quick-pricer"],
		path: "/quick-pricer",
		icon: <MonetizationOnOutlinedIcon sx={{ fontSize: "32px" }} />,
	},
	{
		title: "Resources",
		url: "resource-library",
		path: "/resource-library",
		icon: <FolderOutlinedIcon sx={{ fontSize: "32px" }} />,
	},
	{
		title: "Price my Loan",
		url: "",
		path: "https://www.lfclift.com/",
		icon: <MonetizationOnOutlinedIcon sx={{ fontSize: "32px" }} />,
	},
	{
		title: "Order Appraisal",
		url: "",
		path: "https://lender.reggora.com/auth/login",
		icon: <OrderAppraisalIcon />,
	},
	{
		title: "Messages",
		url: "messages",
		path: "/messages",
		icon: <MessageOutlinedIcon extraStyles={{ fontSize: "32px" }} />,
	},
	{
		title: "Schedule Training",
		url: "",
		path: "https://appt.link/train-with-logan-finance/submission-portal-training",
		icon: <ScheduleTrainingIcon extraStyles={{ fill: "transparent" }} />,
	},
	{
		title: "Training Videos",
		url: "",
		path: "https://loganfinance.com/loganconnect-videos/",
		icon: <PlayCircleOutlinedIcon extraStyles={{ fill: "transparent" }} />,
	},
	{
		title: "Settings",
		url: "settings",
		path: "/settings",
		icon: <SettingsOutlinedIcon sx={{ fontSize: "32px" }} />,
	},
];

export const drawerBottomData = [
	{
		title: "Admin",
		url: "admin",
		path: "/admin",
		icon: <PersonOutlinedIcon sx={{ fontSize: "32px" }} />,
	},
];
